import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { LoginResponse, IntegrationTokenPayloadInfo } from '@models/swagger';
import { LoginParams } from './service';

export enum LoginActions {
  Failure = '[Authentications Login] Failure',
  Request = '[Authentications Login] Request',
  Success = '[Authentications Login] Success',
}

export const LoginFailure = createAction(LoginActions.Failure, props<{ error: HttpErrorResponse }>());

export const LoginRequest = createAction(
  LoginActions.Request,
  props<{ body: IntegrationTokenPayloadInfo; parameters?: LoginParams }>()
);

export const LoginSuccess = createAction(LoginActions.Success, props<{ data: LoginResponse }>());
